import {
    UPDATE_SURGERY_DETAILS,
    UPDATE_SURGERY_DETAILS_SUCCESS,
    UPDATE_SURGERY_DETAILS_FAILURE,
    RESET_CREATE_UPDATE_SURGERY,
} from '../actions';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const initialState = {
    updateSurgery: {
        data: {},
        statusCode: '',
        statusMessage: '',
    },
    updateSurgeryLoading: false,
    callOrderOrCalendar: false,
    isCalendarReload: false,
};

const updateSurgeryReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_SURGERY_DETAILS:
            return {
                ...state,
                updateSurgeryLoading: true,
            };
        case UPDATE_SURGERY_DETAILS_SUCCESS:
            return {
                ...state,
                updateSurgery: {
                    data: action.data,
                    statusCode: '10011',
                },
                updateSurgeryLoading: false,
                callOrderOrCalendar: !state.callOrderOrCalendar,
                isCalendarReload: true
            };
        case UPDATE_SURGERY_DETAILS_FAILURE:
            return {
                ...state,
                updateSurgery: {
                    data: {},
                    message: action.data.message,
                    statusCode: '422',
                },
                updateSurgeryLoading: false,
            };
        case RESET_CREATE_UPDATE_SURGERY:
            return initialState;
        default: {
            return { ...state };
        }
    }
};
export default persistReducer(
    {
        key: 'updateSurgerySubmissionKey',
        storage: storage,
    },
    updateSurgeryReducer
);
